module.exports = __webpack_public_path__ + "img/edit-date.f47c20a4.png";